// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoBg-module--wrapper--3agtL","isPlaying":"VideoBg-module--isPlaying--3_huT","placeholder":"VideoBg-module--placeholder--3vRQ8"};